import React from "react";
import {
  Container,
  Wrapper,
  LinkInterno,
  Logo,
  Open,
  Menu,
  NavButton,
  Divider,
} from "./nav.styles";
import DropdownMenu from "../DropdownMenu/dropdownMenu";
interface Props {
  toggle: any;
  open: boolean;
}

const Nav: React.FC<Props> = ({ toggle, open }) => {
  return (
    <Container>
      <Wrapper>
        <LinkInterno href="https://www.abbiamolog.com/">
          <Logo src="/logo_png.png" />
        </LinkInterno>
        <Open onClick={toggle} open={open}>
          <div />
          <div />
          <div />
        </Open>
        <Menu>
          <LinkInterno href="https://www.abbiamolog.com/">
            <span>Home</span>
          </LinkInterno>

          <LinkInterno href="https://www.abbiamolog.com/#comp-lgfjr0a3">
            <span>Plataforma</span>
          </LinkInterno>

          <DropdownMenu
            title="Soluções"
            options={[
              {
                label: "Farmácias",
                path: "https://www.abbiamolog.com/farmacias",
              },
              {
                label: "Supermercados",
                path: "https://www.abbiamolog.com/supermercados",
              },
              {
                label: "Varejo de Moda",
                path: "https://www.abbiamolog.com/varejo-moda",
              },
              {
                label: "Autopeças",
                path: "https://www.abbiamolog.com/autope%C3%A7as",
              },
            ]}
          />

          <LinkInterno to="/blog/" active>
            <span>Blog</span>
          </LinkInterno>
          <Divider>
            <NavButton href="https://www.abbiamolog.com/#contato">
              Fale conosco
            </NavButton>
          </Divider>
        </Menu>
      </Wrapper>
    </Container>
  );
};

export default Nav;
